import React from 'react'
import { QueryClientProvider } from '@tanstack/react-query'

import { deliveryPerformanceQueryClient } from 'queryClients/deliveryPerformance'

import { useWarehouseSelection } from 'containers/DeliveryPerformanceList/hooks/useWarehouseSelection'
import { DeliveryPerformanceListHeader } from 'containers/DeliveryPerformanceList/components/DeliveryPerformanceListHeader'

import { useDeliveryPerformanceCsvDownloadController } from './hooks/useDeliveryPerformanceCsvDownloadController'
import { DeliveryPerformanceCsvDownloadView } from './components/DeliveryPerformanceCsvDownloadView'

const DeliveryPerformanceCsvDownloadPageInner: React.FC = () => {
  const {
    warehouseId,
    tenantId,
    warehouseOptions,
    tenantOptions,
    changeWarehouseId,
    changeTenantId,
  } = useWarehouseSelection()
  const controller = useDeliveryPerformanceCsvDownloadController({ tenantId })

  return (
    <>
      <DeliveryPerformanceListHeader
        warehouseId={warehouseId}
        tenantId={tenantId}
        warehouseOptions={warehouseOptions}
        tenantOptions={tenantOptions}
        changeWarehouseId={changeWarehouseId}
        changeTenantId={changeTenantId}
      />
      <DeliveryPerformanceCsvDownloadView {...controller} />
    </>
  )
}

export const DeliveryPerformanceCsvDownloadPage: React.FC = () => (
  <QueryClientProvider client={deliveryPerformanceQueryClient}>
    <DeliveryPerformanceCsvDownloadPageInner />
  </QueryClientProvider>
)
